export default "__VITE_ASSET__a9640a44__"